// scheduling/components/OutlookAnnounceModal.jsx
// One-time first-run announcement for the new Outlook Calendar Sync (Trello #133).
// Hybrid: inline [Enable sync] / [Not now] for a one-click decision, plus a
// "Manage in Settings ⚙️" link that opens the Settings modal (Outlook section pulsed).
// Shown once per browser (localStorage gate lives in AppShell); skipped for anyone
// already opted in.

export default function OutlookAnnounceModal({ open, onEnable, onDismiss, onOpenSettings, busy }) {
  if (!open) return null;
  return (
    <div className="app-modal-overlay" onClick={busy ? undefined : onDismiss}>
      <div className="app-modal app-announce-modal" onClick={(e) => e.stopPropagation()}>
        <button className="app-modal-close" onClick={onDismiss} aria-label="Dismiss" disabled={busy}>×</button>
        <div className="app-announce-badge">New</div>
        <h2 className="app-modal-title">📅 Outlook Calendar Sync</h2>
        <p className="app-announce-lead">
          Your RPRS schedule can now show up on your Outlook calendar automatically — as
          all-day, non-blocking events that sit at the top of each day. They never conflict
          with your meetings, and update whenever your schedule changes.
        </p>
        <ul className="app-announce-list">
          <li>One event per scheduled day, showing the hours + client / job.</li>
          <li>Completely optional and private to you — turn it on or off anytime.</li>
          <li>Managed by RPRS — edits made in Outlook don't sync back.</li>
        </ul>
        <div className="app-announce-footer">
          <button className="app-settings-btn app-settings-btn--primary" disabled={busy} onClick={onEnable}>
            {busy ? 'Enabling…' : 'Enable sync'}
          </button>
          <button className="app-settings-btn" disabled={busy} onClick={onDismiss}>Not now</button>
          <button className="app-announce-link" disabled={busy} onClick={onOpenSettings}>
            Manage in Settings ⚙️
          </button>
        </div>
      </div>
    </div>
  );
}
